export default {
  en: {
    'SAVE': 'Save',
    'UPDATE_REPORT': 'Update',
    'SAVE_AS': 'Save As',
    'DELETE_CONFIRMATION_TITLE': 'Confirm Delete',
    'VISIBILITY': 'Visibility',
    'PERSONAL': 'Personal',
    'SHARED': 'Shared'
  }
};